/* eslint-disable no-unused-vars */
import { getVueH } from '@/main'
import { HC_COL_PRESET_TYPE_VXE_GRID_ENUM } from '@/services/enums'
import { filterStr } from '@/services/mixins/modules/tablePubMixin'
import { commaNum } from '@/services/utils'
import { getEstimatedWidthOfDomSpan, isNullOrUndefinedOrEmptyStr } from '@/services/utils/modules/base'
import { isFunction } from 'lodash'
import Vue from 'vue'
import { isArray, isString } from 'xe-utils'
import { isNumber } from 'zrender/lib/core/util'
import HcOperationCol from '@/components/HcOperationCol'

const getTitleTipLabel = (titleTip) => {
  if (isFunction(titleTip)) {
    return titleTip()
  }

  return titleTip
}

/**
 * 处理 vxe-grid 慧策自定义column的 预设
 * hcPreset: {
 *  type: HC_COL_PRESET_TYPE_VXE_GRID
 * }
 * @param {} column
 */
export const handleColPresetType = (column) => {
  // 手动赖注入jsx依的h
  const h = getVueH()

  const { hcPreset, field: propsColField } = column
  if (!hcPreset) {
    return
  }

  const {
    type,
    sortable = true,
    titleTip,
    autoWidthFields = [],
    noMultiple, // 百分比下不乘100 直接添加百分号
    negativeEmpty, // -1为空显示-
    autoTooltip = false,
    autoTooltipLimit = 1,
    isDate = false,
    // 操作列需要的数据
    operationOptions = [],
    operationHandler = () => {},
    isAmountObj = false,
    // 金额类型特有字段
    currencySymbol: presetCurrencySymbol, // 指定货币符号
    currencySymbolField: presetCurrencySymbolField, // 指定货币符号字段
    comma = false, // 是否逗号分割
    commaDecimal = 0, // 精度, 保留小数位数
  } = hcPreset
  if (!type) {
    return
  }

  let curPresetCol = {}

  if (type === HC_COL_PRESET_TYPE_VXE_GRID_ENUM.text.value) {
    curPresetCol = {
      align: 'left',
      minWidth: 120,
      formatter: filterStr,
      slots: {
        header: ({ row = {}, column = {} }) => {
          const { field = '', title = '' } = column
          const propertValue = row[field] || ''
          const titleTipLabel = getTitleTipLabel(titleTip)

          return [
            <div>
              <span>{title}</span>
              {titleTipLabel && <Tips tips={titleTipLabel} width={250}></Tips>}
            </div>,
          ]
        },
        default: ({ row = {}, column = {} }) => {
          const { field = '', title = '' } = column
          const propertValue = row[field]

          if (isNullOrUndefinedOrEmptyStr(propertValue)) {
            return [
              '-'
            ]
          }

          if (autoTooltip) {
            // 当宽度不够, 且要自动提示的时候
            return [
              <TipsStr limit={autoTooltipLimit} content={propertValue}></TipsStr>,
            ]
          }

          return [
            <span>{propertValue}</span>,
            // <div>{propertValue}</div>,
          ]
        }
      },
      hcPreset: {
        // 目前这个是互斥的, autoTooltip优先级更高, autoWidth 优先级低一点
        autoWidth: !autoTooltip,
        getMaxColWidth: (tableData = [], columnInner = {}) => {
          const { field } = columnInner
          // canvas最大宽度
          let maxWidth = 0
          // 最大长度
          let maxSize = 0
          // 最大长度的 字符串
          let maxSizeFieldValue = ''

          tableData.forEach(row => {
            // 未提影响宽度的 feild, 默认使用 columnInner.field
            let autoWidthFieldsFinal = []
            if (autoWidthFields.length === 0) {
              autoWidthFieldsFinal = [field]
            } else {
              // 指定了计算宽度的字段
              autoWidthFieldsFinal = autoWidthFields
            }

            autoWidthFieldsFinal.forEach(item => {
              const fieldValue = String(row[item])
              if (fieldValue.length > maxSize) {
                maxSize = fieldValue.length
                maxSizeFieldValue = fieldValue
              }
            })
          })

          // 使用canvas预估最长的字符串所占用的宽度
          maxWidth = getEstimatedWidthOfDomSpan(maxSizeFieldValue)
          return maxWidth
        },
      },
    }
  } else if (type === HC_COL_PRESET_TYPE_VXE_GRID_ENUM.time.value) {
    curPresetCol = {
      align: 'left',
      width: 120,
      formatter: filterStr,
      slots: {
        header: ({ row = {}, column = {} }) => {
          const { field = '', title = '' } = column
          const propertValue = row[field]
          const titleTipLabel = getTitleTipLabel(titleTip)

          return [
            <div>
              <span>{title}</span>
              {titleTipLabel && <Tips tips={titleTipLabel} width={250}></Tips>}
            </div>,
          ]
        },
        default: ({ row = {}, column = {} }) => {
          const { field = '', title = '' } = column
          const propertValue = row[field]

          if (isNullOrUndefinedOrEmptyStr(propertValue)) {
            return [
              '-'
            ]
          }

          const splitedValue = propertValue.split(' ')
          if (isDate) {
            // 只显示日期
            return [
              <div>{splitedValue[0]}</div>
            ]
          } else if (splitedValue.length === 2) {
            // 日期 时间 换行显示
            return [
              <div>{splitedValue[0]}</div>,
              <div>{splitedValue[1]}</div>
            ]
          } else {
            // 有问题的数据，直接显示
            return [
              <div>{propertValue}</div>
            ]
          }
        }
      },
      hcPreset: {
        autoWidth: false,
      },
    }
  } else if (type === HC_COL_PRESET_TYPE_VXE_GRID_ENUM.amount.value) {
    curPresetCol = {
      align: 'right',
      minWidth: '150px',
      sortable,
      sortBy: isAmountObj ? `${propsColField}.amount` : propsColField,
      slots: {
        header: ({ row = {}, column = {} }) => {
          const { field = '', title = '' } = column
          const fieldValue = row[field]
          const titleTipLabel = getTitleTipLabel(titleTip)

          return [
            <div>
              <span>{title}</span>
              {titleTipLabel && <Tips tips={titleTipLabel} width={250}></Tips>}
            </div>,
          ]
        },
        default: ({ row }) => {
          const { field = '', title = '' } = column
          const fieldValue = row[field]

          const currencySymbol = row.currencySymbol || row.currencyType
          const currencyCode = row.currencyCode

          let currencySymbolFinal = currencySymbol
          let currencyCodeFinal = currencyCode
          let amountFinal = fieldValue

          // 预设里面指定货币符号或者货币符号字段
          if (presetCurrencySymbol) {
            currencySymbolFinal = presetCurrencySymbol
          } else if (presetCurrencySymbolField) {
            currencySymbolFinal = row[presetCurrencySymbolField]
          }

          if (isAmountObj) {
            // amount 信息全部放在一个对象里面
            currencySymbolFinal = fieldValue.currencySymbol
            currencyCodeFinal = fieldValue.currencyCode
            amountFinal = fieldValue.amount
          }

          if (negativeEmpty && amountFinal === -1) {
            return [
              <span>-</span>
            ]
          }

          return [
            <div>
              <AmountShow currencyCode={currencyCodeFinal} currencySymbol={currencySymbolFinal} amount={amountFinal} isShowDefault />
            </div>
          ]
        }
      },
      hcPreset: {
        autoWidth: true,
        footerAutoWidthDom: true,
        getMaxColWidth: (tableData = [], columnInner = {}) => {
          const { field } = columnInner
          // canvas最大宽度
          let maxWidth = 0
          // 最大长度
          let maxSize = 0
          // 最大长度的 字符串
          let maxSizeFieldValue = ''

          tableData.forEach(row => {
            const fieldValue = String(row[field])
            const currencySymbol = row.currencySymbol
            const fieldValueFinal = currencySymbol + ' ' + commaNum(fieldValue, 2)

            if (fieldValueFinal.length > maxSize) {
              maxSize = fieldValueFinal.length
              maxSizeFieldValue = fieldValueFinal
            }
          })
          // 使用canvas预估最长的字符串所占用的宽度
          maxWidth = getEstimatedWidthOfDomSpan(maxSizeFieldValue)
          return maxWidth
        },
      }
    }
  } else if (type === HC_COL_PRESET_TYPE_VXE_GRID_ENUM.quantity.value) {
    curPresetCol = {
      align: 'right',
      minWidth: 100,
      sortable,
      slots: {
        header: ({ row = {}, column = {} }) => {
          const { field = '', title = '' } = column
          const fieldValue = row[field] || ''
          const titleTipLabel = getTitleTipLabel(titleTip)

          return [
            <div>
              <span>{title}</span>
              {titleTipLabel && <Tips tips={titleTipLabel} width={250}></Tips>}
            </div>,
          ]
        },
        default: ({ row }) => {
          const { field = '', title = '' } = column
          let fieldValue = row[field]

          if (isNullOrUndefinedOrEmptyStr(fieldValue)) {
            return [
              <span>-</span>
            ]
          } else if (negativeEmpty && fieldValue === -1) {
            return [
              <span>-</span>
            ]
          }

          if (comma) {
            fieldValue = commaNum(fieldValue, commaDecimal)
          }

          return [
            <span>{fieldValue}</span>
          ]
        }
      },
      hcPreset: {
        autoWidth: true,
        footerAutoWidthDom: true,
        getMaxColWidth: (tableData = [], columnInner = {}) => {
          const { field } = columnInner
          // canvas最大宽度
          let maxWidth = 0
          // 最大长度
          let maxSize = 0
          // 最大长度的 字符串
          let maxSizeFieldValue = ''

          tableData.forEach(row => {
            const fieldValue = String(row[field])
            if (fieldValue.length > maxSize) {
              maxSize = fieldValue.length
              maxSizeFieldValue = fieldValue
            }
          })
          // 使用canvas预估最长的字符串所占用的宽度
          maxWidth = getEstimatedWidthOfDomSpan(maxSizeFieldValue)
          return maxWidth
        },
      },
    }
  } else if (type === HC_COL_PRESET_TYPE_VXE_GRID_ENUM.percentage.value) {
    curPresetCol = {
      align: 'right',
      minWidth: 100,
      sortable,
      slots: {
        header: ({ row = {}, column = {} }) => {
          const { field = '', title = '' } = column
          const fieldValue = row[field]
          const titleTipLabel = getTitleTipLabel(titleTip)

          return [
            <div>
              <span>{title}</span>
              {titleTipLabel && <Tips tips={titleTipLabel} width={250}></Tips>}
            </div>,
          ]
        },
        default: ({ row }) => {
          const { field = '', title = '' } = column
          const fieldValue = row[field]

          if (isNullOrUndefinedOrEmptyStr(fieldValue)) {
            return [
              <span>-</span>
            ]
          } else if (negativeEmpty && fieldValue === -1) {
            return [
              <span>-</span>
            ]
          }

          let fieldValueFixed = fieldValue
          if (isString(fieldValue)) {
            fieldValueFixed = String(fieldValue).endsWith('%') ? fieldValue : commaNum(fieldValue, 2) + '%'
          } else if (isNumber(fieldValue)) {
            if (noMultiple) {
              fieldValueFixed = commaNum(fieldValue, 2) + '%'
            } else {
              fieldValueFixed = commaNum(fieldValue * 100, 2) + '%'
            }
          }

          return [
            <span>{fieldValueFixed}</span>
          ]
        }
      },
      hcPreset: {
        autoWidth: true,
        getMaxColWidth: (tableData = [], columnInner = {}) => {
          const { field } = columnInner
          // canvas最大宽度
          let maxWidth = 0
          // 最大长度
          let maxSize = 0
          // 最大长度的 字符串
          let maxSizeFieldValue = ''

          tableData.forEach(row => {
            const fieldValue = String(row[field])
            const fieldValueWithSymbol = String(fieldValue).endsWith('%') ? String(fieldValue) : String(fieldValue) + '%'
            if (fieldValueWithSymbol.length > maxSize) {
              maxSize = fieldValueWithSymbol.length
              maxSizeFieldValue = fieldValueWithSymbol
            }
          })
          // 使用canvas预估最长的字符串所占用的宽度
          maxWidth = getEstimatedWidthOfDomSpan(maxSizeFieldValue)
          return maxWidth
        },
      },
    }
  } else if (type === HC_COL_PRESET_TYPE_VXE_GRID_ENUM.operation.value) {
    curPresetCol = {
      align: 'left',
      width: 50,
      formatter: filterStr,
      slots: {
        header: ({ row = {}, column = {} }) => {
          const { field = '', title = '' } = column
          const propertValue = row[field] || ''
          const titleTipLabel = getTitleTipLabel(titleTip)

          return [
            <div>
              <span>{title}</span>
              {titleTipLabel && <Tips tips={titleTipLabel} width={250}></Tips>}
            </div>,
          ]
        },
        default: ({ row = {}, column = {} }) => {
          const { field = '', title = '' } = column
          const propertValue = row[field]

          if (isNullOrUndefinedOrEmptyStr(operationOptions)) {
            return [
              '-'
            ]
          }

          const operationOptionsArr = isFunction(operationOptions) ? operationOptions({ row }) : operationOptions

          let options = []
          if (operationOptionsArr.length <= 3) {
            options = operationOptionsArr
          } else {
            options = [
              operationOptionsArr[0],
              operationOptionsArr[1],
              {
                label: 'more',
                value: 'more',
                children: operationOptionsArr.slice(2),
              }
            ]
          }
          return [
            <HcOperationCol options={options} onCommand={(cmd) => operationHandler({ row, cmd })}></HcOperationCol>,
          ]
        }
      },
      hcPreset: {
        // 目前这个是互斥的, autoTooltip优先级更高, autoWidth 优先级低一点
        autoWidth: !autoTooltip,
        autoWidthDom: true,
      },
    }
  } else if (type === HC_COL_PRESET_TYPE_VXE_GRID_ENUM.image.value) {
    curPresetCol = {
      align: 'left',
      width: 80,
      formatter: filterStr,
      slots: {
        header: ({ row = {}, column = {} }) => {
          const { field = '', title = '' } = column
          const propertValue = row[field] || ''
          const titleTipLabel = getTitleTipLabel(titleTip)

          return [
            <div>
              <span>{title}</span>
              {titleTipLabel && <Tips tips={titleTipLabel} width={250}></Tips>}
            </div>,
          ]
        },
        default: ({ row = {}, column = {} }) => {
          const { field = '', title = '' } = column
          const propertValue = row[field]

          // if (isNullOrUndefinedOrEmptyStr(propertValue)) {
          //   return [
          //     '-'
          //   ]
          // }

          return [
            <ImgPopover url={propertValue} />
          ]
        }
      },
      hcPreset: {
        // 目前这个是互斥的, autoTooltip优先级更高, autoWidth 优先级低一点
        autoWidth: false,
        autoWidthDom: false,
      },
    }
  } else if (type === HC_COL_PRESET_TYPE_VXE_GRID_ENUM.checkbox.value) {
    curPresetCol = {
      align: 'center',
      width: 50,
      type: 'checkbox',
      title: '',
    }
  }

  // 改变
  const finalColumn = {
    ...curPresetCol,
    ...column,
  }
  // handle slots
  const finalSlots = {
    ...(curPresetCol.slots || {}),
    ...(column.slots || {}),
  }

  const finalHcPreset = {
    ...(curPresetCol.hcPreset || {}),
    ...(column.hcPreset || {}),
  }

  if (Object.values(finalSlots).length > 0) {
    finalColumn.slots = finalSlots
  }

  if (Object.values(finalHcPreset).length > 0) {
    finalColumn.hcPreset = finalHcPreset
  }

  // 改变原来的column, 高级用法
  Object.assign(column, finalColumn)

  if (type === HC_COL_PRESET_TYPE_VXE_GRID_ENUM.checkbox.value) {
    // 去掉title
    column.title = ''
  }

  return finalColumn
}
